export const fontFamily = {
    'recklessXPD': `"Reckless XPD", "Reckless XPD Book", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;`,
    'PPEiko': `"PP Eiko"`,
    'lardentProSlab': `"Lardent Pro", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;`,
    'centraNo2': `"Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;`,
    'travelSans': `"Travel Sans", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;`,
    'FreightSansLF': `FreightSansLF Pro,Noto Sans JP,Noto Sans KR,Helvetica Neue,Helvetica,Arial,Lucida Grande,Segoe UI,Tahoma,-apple-system,Roboto,sans-serif!important`
};

export const fontSize = {
    'fontSize01': '64px',
    'fontSize02': '56px',
    'fontSize03': '40px',
    'fontSize04': '32px',
    'fontSize05': '28px',
    'fontSize06': '24px',
    'fontSize07': '21px',
    'fontSize08': '18px',
    'fontSize09': '16px',
    'fontSize10': '14px',
    'fontSize11': '12px',
    'fontSize12': '10px',
    'fontSpacingspace24' : '24px'
};
export const unitlessFontSize = {
    'fontSize01': '64',
    'fontSize02': '56',
    'fontSize03': '40',
    'fontSize04': '32',
    'fontSize05': '28',
    'fontSize06': '24',
    'fontSize07': '21',
    'fontSize08': '18',
    'fontSize09': '16',
    'fontSize10': '14',
    'fontSize11': '12',
    'fontSize12': '10',
    'fontSpacingspace24' : '24'
};

export const fontLineHeight = {
    'fontLineHeight01': '68px',
    'fontLineHeight02': '64px',
    'fontLineHeight03': '44px',
    'fontLineHeight04': '36px',
    'fontLineHeight05': '32px',
    'fontLineHeight06': '26px',
    'fontLineHeight07': '24px',
    'fontLineHeight08': '20px',
    'fontLineHeight09': '16px',
    'fontLineHeight10': '12px',
};

export const unitlessFontLineHeight = {
    'fontLineHeight01': '68',
    'fontLineHeight02': '64',
    'fontLineHeight03': '44',
    'fontLineHeight04': '36',
    'fontLineHeight05': '32',
    'fontLineHeight06': '26',
    'fontLineHeight07': '24',
    'fontLineHeight08': '20',
    'fontLineHeight09': '16',
    'fontLineHeight10': '12',
};

export const fontWeight = {
    'RecklessXPD_Book': '',
    'RecklessXPD_Bold': '',
    'RecklessXPD_Book_Italics': '',
    'PPEiko_Medium': '',
    'PPEiko_Medium_Italics': '',
    'TravelSans_Bold': '',
    'TravelSans_Bold_Italics': '',
    'TravelSans_Regular': '',
    'TravelSans_Regular_Italics': '',
    'TravelSans_Italics': '',
    'LardentPro_Regular': '300',
    'CentraNo2_Medium_Italics': '',
    'CentraNo2_Medium': '',
    'CentraNo2_Book': '',
    'CentraNo2_Book_Italics': '',
}

type FontFamilyKey = keyof typeof fontFamily;

export const getOverrideFontFamily = (fontName: FontFamilyKey): string | null => {
    if (fontFamily[fontName]) {
        return fontFamily[fontName].replace(';', ' !important;');
    } else {
        return null;
    }
}
